<template>
	<div class="panel_sale">
		<div class="list" v-if="type==='list'">
			<activityList></activityList>
		</div>
		<div class="add" v-if="type==='add'">
			活动详情
		</div>
	</div>
</template>
<script>
	import activityList from "./comp/activity_list.vue"
	export default {
		components:{activityList},
		data(){
			return{
				
			}
		},
		computed:{
			type(){
				return this.$store.state.activity.type;
			}
		},
		mounted(){
			
		},
		methods: {
			
		},
	}
</script>
<style scoped lang="scss">
.panel_sale{
	position: relative;
	width:100%;
	height: 100%;
	.list{
		height: 100%;
	}
	.add{
		height: 100%;
	}
}
</style>
